import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  targetDatabaseId: null,
  availableColumns: [],
  queries: [],
});

const onLoadData = (rawData) => {
  const data = { ...initData(), ...rawData };
  // v1 compat: availableCols → availableColumns
  if (rawData.availableCols && !rawData.availableColumns) {
    data.availableColumns = rawData.availableCols;
    delete data.availableCols;
  }
  // v1 compat: queryData → queries
  if (rawData.queryData && !rawData.queries) {
    data.queries = rawData.queryData;
    delete data.queryData;
  }
  // Keep both field names for backward compat with old template
  if (!data.availableCols && data.availableColumns) {
    data.availableCols = data.availableColumns;
  }
  if (!data.queryData && data.queries) {
    data.queryData = data.queries;
  }
  // Normalize query item field names:
  // Backend stores "function"/"columnKey", UI expects "outputFunc"/"value"
  const normalizeQueryItems = (items) =>
    items.map((q) => {
      const item = { ...q };
      if (item.function && !item.outputFunc) {
        item.outputFunc = item.function.toUpperCase();
        delete item.function;
      }
      if (item.columnKey !== undefined && item.value === undefined) {
        item.value = item.columnKey;
        delete item.columnKey;
      }
      return item;
    });
  if (Array.isArray(data.queries)) {
    data.queries = normalizeQueryItems(data.queries);
  }
  if (Array.isArray(data.queryData)) {
    data.queryData = normalizeQueryItems(data.queryData);
  }
  return data;
};

const { getStore: getQueryDatabaseStore, defaultStore } = createComponentStore({
  type: 'query_database',
  endpoint: 'query_database_record',
  registryKey: 'query_database_record',
  initData,
  onLoadData,

  extraState: (set, get) => ({
    placeholders: [],
    position: null,
    focus: null,
  }),

  extraActions: (set, get) => ({
    // Backward-compat alias — delegates to the factory-provided setComponentData
    setUpdateDatabaseRecordTemplate: (component) => {
      get().setComponentData(component);
    },

    setData: (data) => set({ data: JSON.parse(JSON.stringify(data)) }),

    setAvailableCols: (availableCols) => {
      const cols = [...availableCols];
      set({ data: { ...get().data, availableColumns: cols, availableCols: cols } });
    },

    setQueryData: (queryData) => {
      const q = [...queryData];
      set({ data: { ...get().data, queries: q, queryData: q } });
    },

    clearQueryData: () => {
      set({ data: { ...get().data, queries: [], queryData: [] } });
    },

    clearData: () => {
      set({ data: { ...get().data, columns: [] } });
    },

    setTargetDatabaseId: (targetDatabaseId) => {
      set({ data: { ...get().data, targetDatabaseId } });
    },

    setPlaceholders: (placeholders) => set({ placeholders: [...placeholders] }),

    setFocus: (index, focus) => {
      set({ position: index, focus, placeholders: [] });
    },

    // Override base getTemplate to include UI-only fields (placeholders, position, focus)
    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
        placeholders: [...s.placeholders],
        position: s.position,
        focus: s.focus,
      };
    },
  }),
});

export { getQueryDatabaseStore };
export default defaultStore;
